import React from 'react';
import './App.css';
import { KalustomestariLee } from './KalustomestariLee';
import { Pingis } from './Pingis';
import { Intro } from './Intro';
import { Lopetus } from './Lopetus';
import { Tennis } from './Tennis';
import { Aidajuoksu } from './Aidajuoksu';
import { Alppitorvihiihto } from './Alppitorvihiihto';
import { Triolithon } from './Triolithon';
import { Treeniohjelma } from './Treeniohjelma';
import { Sitsilaulut } from './Sitsilaulut';

function App() {
  // useEffect(() => {
  //   document.body.className = 'modal-open';
  // });

  return (
    <div className="App">
      <nav className="c1">
        <a href="/" className="link">
          waputin.fi etusivulle
        </a>
      </nav>
      <div className="banneri"></div>
      <div className="c1">
        <Intro />
      </div>
      <div className="banneri"></div>
      <div className="c1">
        <Sitsilaulut />
      </div>
      <div className="c1">
        <Tennis />
      </div>
      <div className="c1">
        <Treeniohjelma />
      </div>
      <div className="c1">
        <Aidajuoksu />
      </div>
      <div className="c1">{<Pingis />}</div>
      <div className="c1">
        <Alppitorvihiihto />
      </div>
      <div className="c1">
        <KalustomestariLee />
      </div>
      <div className="c1">
        <Triolithon />
      </div>
      <div className="banneri"></div>
      <div className="c1">
        <Lopetus />
      </div>
    </div>
  );
}

export default App;
